import React, { createContext, useState } from "react";
import { GROUP_LABELS } from "../constants/constants";

export const DataContext = createContext({});

const groupPopUp = localStorage.getItem("groupPopUp");

const initialCreateGroupAlert = {
  status: groupPopUp || "initial",
  message: (
    <>
      <p>{GROUP_LABELS.alertMessages.planQuestion}</p>
      <p>{GROUP_LABELS.alertMessages.createGroupQuestion}</p>
    </>
  ),
};
export const DataProvider = ({ children }) => {
  const [reservation, setReservation] = useState(null);
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [availibility, setAvailibility] = useState(null);
  const [itineraryData, setItineraryData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [groupData, setGroupData] = useState({ items: [], groupName: "" });
  const [pagesData, setPagesData] = useState([]);
  const [isOnValidState, setIsOnValidState] = useState(false);
  const [isKioskRedirect, setIsKioskRedirect] = useState(false);
  const [isLate, setLate] = useState(false);
  const [dayUseDetails, setDayUseDetails] = useState(null);
  const [showDiningAddOnsPopup, setShowDiningAddOnsPopup] = useState(false);
  const [activityToBeDeleted, setActivityToBeDeleted] = useState([]);
  const [cardBannerContent, setCardBannerContent] = useState({});
  const [showFolio, setShowFolio] = useState(false);
  const [landingPage, setLandingPage] = useState([]);
  const [promotionalSpaceContent, setPromotionalSpaceContent] = useState([]);
  const [
    diningProcessingScreenBannerTexts,
    setDiningProcessingScreenBannerTexts,
  ] = useState([]);
  const [
    promotionalSpaceItineraryExpandedRowsDetails,
    setPromotionalSpaceItineraryExpandedRowsDetails,
  ] = useState([]);
  const [createGroupAlert, setCreateGroupAlert] = useState(
    initialCreateGroupAlert
  );
  const [allSpaAvailability, setAllSpaAvailability] = useState(null);
  const [singleSpaAvailability, setSingleSpaAvailability] = useState([]);
  const [maintenanceData, setMaintenanceData] = useState({});
  const [booked, setBooked] = useState({});
  const [giftCardsPage, setGiftCardsPage] = useState(null);
  const [ESPSpaPage, setESPSpaPage] = useState(null);
  const [golfPage, setGolfPage] = useState(null);

  const clearOnLogOut = (setView) => {
    setReservation(null);
    setFacilitiesData([]);
    setAvailibility([]);
    setItineraryData(null);
    setSelectedDate(null);
    setGroupData({ items: [], groupName: "" });
    setPagesData([]);
    setIsOnValidState(false);
    setLate(false);
    setActivityToBeDeleted([]);
    setCardBannerContent({});
    setView({ type: "" });
    setCreateGroupAlert({
      ...initialCreateGroupAlert,
      status: "initial",
    });
    localStorage.removeItem("groupPopUp");
  };

  return (
    <DataContext.Provider
      value={{
        reservation,
        facilitiesData,
        availibility,
        itineraryData,
        selectedDate,
        isLate,
        isOnValidState,
        activityToBeDeleted,
        groupData,
        pagesData,
        cardBannerContent,
        allSpaAvailability,
        singleSpaAvailability,
        landingPage,
        diningProcessingScreenBannerTexts,
        promotionalSpaceItineraryExpandedRowsDetails,
        promotionalSpaceContent,
        createGroupAlert,
        maintenanceData,
        setMaintenanceData,
        isKioskRedirect, 
        dayUseDetails, 
        setDayUseDetails,
        setIsKioskRedirect,
        setCreateGroupAlert,
        showDiningAddOnsPopup, 
        setShowDiningAddOnsPopup,
        setPagesData,
        setGroupData,
        setActivityToBeDeleted,
        setLate,
        setIsOnValidState,
        setSelectedDate,
        setFacilitiesData,
        setAvailibility,
        setReservation,
        setItineraryData,
        setCardBannerContent,
        setLandingPage,
        setDiningProcessingScreenBannerTexts,
        setPromotionalSpaceItineraryExpandedRowsDetails,
        setPromotionalSpaceContent,
        setAllSpaAvailability,
        setSingleSpaAvailability,
        clearOnLogOut,
        booked,
        setBooked,
        showFolio, 
        setShowFolio,
        giftCardsPage,
        setGiftCardsPage,
        ESPSpaPage,
        setESPSpaPage,
        golfPage,
        setGolfPage,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
